export default __webpack_public_path__ + "static/media/profile_tip_title.dcb4c8df.svg";